import * as React from "react";
import cn from "classnames";
import { useField } from "formik";
import { FormLabel } from "../FormLabel";
import styles from "./styles.module.scss";

interface IProps {
    name: string;
    label: string;
    selectClassName?: string;
    children: React.ReactNode;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    disabled?: boolean;
    showValidationErrorWhenNotTouched?: boolean;
    "data-testid"?: string;
}

export function Select({
    name,
    label,
    selectClassName,
    children,
    onChange,
    disabled,
    showValidationErrorWhenNotTouched,
    "data-testid": dataTestId,
}: IProps): JSX.Element {
    const [field] = useField<string>(name);

    return (
        <div>
            <FormLabel
                name={name}
                label={label}
                showValidationErrorWhenNotTouched={
                    showValidationErrorWhenNotTouched
                }
            />

            <select
                className={cn(
                    {
                        [styles.select]: true,
                        [styles.selectDisabled]: disabled,
                    },
                    selectClassName,
                )}
                onChange={onChange}
                value={field.value}
                disabled={disabled}
                data-testid={dataTestId}
                name={name}
            >
                {children}
            </select>
        </div>
    );
}
